// Package imports:
import React from 'react';
// Component imports:
import ScrollSpy from '../../../ui-elements/ScrollSpy/ScrollSpy';
import ScrollSpySection from '../../../ui-elements/ScrollSpy/ScrollSpySection';
import Link from '../../../ui-elements/Link/Link';

const KeldanAppDisclaimerComp: React.FC = () => {
        return (
        <div className='keldanApp'>
            <article className="article-overview">
                <div className="article__body">
                    <ScrollSpy
                        containerClass="article__content"
                        navClass="article__nav"
                        parentClass='keldanApp'
                        initialStep="veitt-thjonusta"
                    >
                        <ScrollSpySection className="article__section" id="veitt-thjonusta" label="Veitt þjónusta">
                            <h2 className="h2">Veitt þjónusta</h2>
                            <p>Keldan veitir áskrifanda aðgang að rauntíma markaðsgögnum í Keldan App. Í upplýsingaþjónustunni felst aðgangur að íslenskum hlutabréfaupplýsingum í rauntíma.</p>
                        </ScrollSpySection>
                        <ScrollSpySection className="article__section" id="askrift" label="Áskrift">
                            <h2 className="h2">Áskrift</h2>
                            <p>Til að gerast áskrifandi verður notandi að kaupa áskrift í forritinu. Áskriftin er endurnýjuð mánaðarlega þangað til henni er sagt upp. 
                                Áskriftin er gjaldfærð fyrir hvern mánuð fyrirfram. 
                                Ef ekki tekst að gjaldfæra verður áskrift að rauntímaupplýsingum lokað og notandi fær aðgang að seinkuðum gögnum.</p>
                        </ScrollSpySection>
                        <ScrollSpySection className="article__section" id="uppsogn" label="Uppsögn á áskrift">
                            <h2 className='h2'>Uppsögn á áskrift</h2>
                            <p>
                                Áskriftir eru rukkaðar í mesta lagi 24 tímum fyrir byrjun næsta áskriftartímabils. 
                                Ef segja á upp áskrift skal það gert í stillingum App Store fyrir iOs eða Play Store fyrir Android. 
                                Segja þarf upp áskrift minnst 24 tímum áður en næsti gjalddagi rennur upp, að öðrum kosti verður áskriftin gjaldfærð og fæst ekki endurgreidd. 
                                Uppsögn tekur gildi daginn fyrir næsta gjalddaga sem uppsögn berst. 
                                Lokast þá aðgengi áskrifanda að rauntímagögnum Keldunnar.
                            </p>
                        </ScrollSpySection>
                        <ScrollSpySection className="article__section" id="endurgreidsla" label="Endurgreiðsla">
                            <h2 className='h2'>Endurgreiðsla</h2>
                            <p>
                                Áskrift getur fengist endurgreidd ef að rauntímagögn berast áskrifanda ekki vegna galla í Keldu appinu.
                            </p>
                        </ScrollSpySection>
                        <ScrollSpySection className="article__section" id="verd" label="Verð">
                            <h2 className='h2'>Verð</h2>
                            <p>
                                Keldan áskilur sér rétt til breytinga á verði og skulu breytingar tilkynntar áskrifanda, með tölvupósti á uppgefið tölvupóstfang áskrifanda.
                            </p>
                        </ScrollSpySection>
                        <ScrollSpySection className="article__section" id="framsal-rettinda" label="Framsal réttinda og miðlun upplýsinga">
                            <h2 className='h2'>Framsal réttinda og miðlun upplýsinga</h2>
                            <p>
                                Áskrifanda er ekki heimilt að framselja áskrift sína til þriðja aðila án samþykkis Keldunnar.
                                Áskrifanda er ekki heimilt að miðla til þriðja aðila upplýsingum sem sóttar eru gegnum App Keldunnar.
                            </p>
                        </ScrollSpySection>
                        <ScrollSpySection className="article__section" id="flokkun-askrifenda" label="Flokkun áskrifenda">
                            <h2 className='h2'>Flokkun áskrifenda</h2>
                            <div>
                                <p>Rauntíma áskrift að Keldu Appinu er eingöngu ætlað einstaklingum.</p>
                                <p>Með því að samþykkja þessa skilmála þá staðfestir áskrifandi að hann flokkist sem einstaklingur.</p>
                                <p> 
                                    Í reglum Kauphallar Íslands eru áskrifendur að rauntíma aðgangi flokkaðir í tvo flokka: fagaðilar “professional” og einstaklingar “private investor”.
                                    Samkvæmt reglum kauphallarinnar er verðmunur á áskriftarleiðum fagaðila og einstaklinga. Áskrifendur verða að staðfesta að þeir flokkist sem einstaklingur.
                                </p>Einstaklingur / Private investor:
                                <p>Persóna (ekki lögaðili eins og hf., ehf., sf. eða slf.) sem starfar ekki við fjármálaráðgjöf.</p>
                                <p>Fagaðili / Professional investor:</p>
                                <p>Hvers konar lögaðili eða fyrirtæki hf., ehf., sf. eða slf. hvort sem starfsemi þess tengist fjármálamarkaði eður ei.</p>
                                <p>Einstaklingur sem starfar við verðbréfamiðlun eða fjárfestingaráðgjöf.</p>
                                <p>
                                    Ef í ljós kemur að áskrifandi flokkist sem fagaðili verður áskrift lokað og kauphöllin áskilur sér þann rétt að rukka viðkomandi samkvæmt verðskrá fagaðila. 
                                    Þeir áskrifendur sem að falla undir fagaðila geta sótt um aðgang að KODIAK Pro með því að senda tölvupóst á <Link url="mailto:help@kodi.is" linkSize='18'>help@kodi.is</Link>.
                                </p>
                                <br/>
                                <p>KELDAN ehf.</p>
                                <p>KT. 491009-0200 - VSK 103750</p>
                                <p>Borgartún 25, 2. hæð, 105 Reykjavík</p>
                                <p>Sími <Link url="tel:+3545101050" linkSize='18'>+354 510 1050</Link></p>
                                <p>Netfang <Link url="mailto:info@kodi.is" linkSize='18'>info@kodi.is</Link></p>
                            </div>
                        </ScrollSpySection>
                    </ScrollSpy>
                </div>
            </article>
        </div >
    )
}

export default KeldanAppDisclaimerComp;

